import { ChatArea } from '@/components/chat';
import { AuthGuard } from '@/guards';
import Sidebar from '@/components/Sidebar';
import DashboardTopbar from '@/components/dashboard/DashboardTopbar';

export default function DashboardPage() {
  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden bg-[color:var(--nt-bg)] text-[color:var(--nt-text)]">
        <div className="flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
          <DashboardTopbar />
          <div className="flex-1 min-h-0 overflow-hidden">
            <ChatArea />
          </div>
        </div>
      </div>
    </AuthGuard>
  );
}
